'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'fan';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f863';
var svgPathData = ['M33 224c7.9 63.1 61.7 112 127 112 15 0 29.3-2.6 42.7-7.3 4.9-1.7 10.3-1 14.6 2s6.8 7.9 6.8 13.1L224 479c63.1-7.9 112-61.7 112-127 0-15-2.6-29.3-7.3-42.7-1.7-4.9-1-10.3 2-14.6s7.9-6.8 13.1-6.8L479 288c-7.9-63.1-61.7-112-127-112-15 0-29.3 2.6-42.7 7.3-4.9 1.7-10.3 1-14.6-2s-6.8-7.9-6.8-13.1L288 33c-63.1 7.9-112 61.7-112 127 0 15 2.6 29.3 7.3 42.7 1.7 4.9 1 10.3-2 14.6s-7.9 6.8-13.1 6.8L33 224zm247 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M176 160c0-65.3 48.9-119.1 112-127l0 135.2c0 5.2 2.5 10.1 6.8 13.1s9.7 3.8 14.6 2c13.3-4.7 27.7-7.3 42.7-7.3 65.3 0 119.1 48.9 127 112l-135.2 0c-5.2 0-10.1 2.5-13.1 6.8s-3.8 9.7-2 14.6c4.7 13.3 7.3 27.7 7.3 42.7 0 65.3-48.9 119.1-112 127l0-135.2c0-5.2-2.5-10.1-6.8-13.1s-9.7-3.8-14.6-2c-13.3 4.7-27.7 7.3-42.7 7.3-65.3 0-119.1-48.9-127-112l135.2 0c5.2 0 10.1-2.5 13.1-6.8s3.8-9.7 2-14.6C178.6 189.3 176 175 176 160zM304 0c-88.4 0-160 71.6-160 160 0 10.9 1.1 21.7 3.2 32L16 192c-8.8 0-16 7.2-16 16 0 88.4 71.6 160 160 160 10.9 0 21.7-1.1 32-3.2L192 496c0 8.8 7.2 16 16 16 88.4 0 160-71.6 160-160 0-10.9-1.1-21.7-3.2-32L496 320c8.8 0 16-7.2 16-16 0-88.4-71.6-160-160-160-10.9 0-21.7 1.1-32 3.2L320 16c0-8.8-7.2-16-16-16zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;